<style lang="scss">
	.channelform .ivu-form-item-error-tip{
		z-index: 99;
	}
</style>
<template>
    <div class="channelform">
		<Breadcrumb class="tablelist-header" v-if="!querytype">
            <BreadcrumbItem to="/">店铺SFP产品添加</BreadcrumbItem>
        </Breadcrumb>
        <compWrapper title="基本信息" theme="primary">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" :labelWidth="120"></compFormEdit>
        </compWrapper>
		<div class="text-right">
			<vButton class="margin-right-10" theme="primary" @click="submit">保存</vButton>
			<vButton @click="cancel">取消</vButton>
		</div>
    </div>
</template>
<script>
import {
	HttpSaveChannelProperty
} from '@/service/products/channel'

import { setTimeout } from 'timers'
import { mapState, mapGetters } from "vuex";

export default {
    data(){
        return {
			formData:{
			orgId:0,
				sellerSku:'',
				accountFlag:'',
				property:'SFP',
			},
		}
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
	},

    computed:{
		...mapState('boss', ['products', 'accounts']),
		accountsAll() {
			return this.accounts.filter(item=>{
                if(item.type=='amazon'){
                    return item;
                }
            })
		},
        getBase(){
            return [
              {
                                  label: "seller sku：",
                                  key: "sellerSku",
                                  tag: "vInput",
                              },
                   {
                                 label: "店铺",
                                 tag: 'vSelect',
                                 key: 'accountFlag',
                                 required:false,
                                 options:this.accountsAll.map(function(item){
                                 return {
                                     value: item.flag,
                                     label: item.flag
                                     }
                                 }),
                                 props:{
                                     filterable:true,
                                 }
                             },
            ]
        }
    },
    methods:{
      submit() {
            this.loading = true;
            this.formData.orgId=global.SYSID;
            HttpSaveChannelProperty(this.formData).then(res => {
           	this.$VMessage.success(res.message);
           				this.$router.push({
                               name: "proSfpList"
                           })
        }).catch(err => {
            this.$VMessage.error({
                content: err.message,
                duration: 30,
                closable: true
            });
            this.loading = false;
        });
        },

		cancel(){
			if(this.querytype == 'edit'){
                this.$emit('on-close')
            }else{
                this.$router.push({
                    name: "proSfpList"
                })
            }
		}
    }
}
</script>
